module.exports = __webpack_public_path__ + "img/8_jobs-and-careers.d6505776.png";